import i18n from '@/plugins/i18n'
export default function commonMethods() {
  const { locale } = i18n.global

  function translate(localizedText) {
    if (typeof localizedText === 'object' && localizedText !== null) {
      return localizedText[locale.value] || localizedText['defaultValue']
    } else {
      return localizedText
    }
  }

  function registerError(err, info) {
    console.log(err)

    let errors = localStorage.getItem('errors')

    if (!errors) {
      errors = JSON.stringify({
        data: [],
        expiry: Date.now() + 3 * 24 * 60 * 60 * 1000
      })
    }

    let jsonErrors = JSON.parse(errors)

    if (Date.now() > jsonErrors.expiry) {
      localStorage.removeItem('errors')
      jsonErrors = {
        data: [],
        expiry: Date.now() + 3 * 24 * 60 * 60 * 1000
      }
    }

    jsonErrors.data.push({
      date:
        new Date(Date.now()).toLocaleDateString() +
        ' ' +
        new Date(Date.now()).toLocaleTimeString(),
      error: err.toString(),
      info: info
    })
    localStorage.setItem('errors', JSON.stringify(jsonErrors))
  }

  function scrollToAnchor(anchor) {
    const element = document.querySelector(anchor)
    if (element) {
      const offset = -20
      const targetPosition =
        element.getBoundingClientRect().top + window.scrollY + offset
      const startPosition = window.scrollY
      const distance = targetPosition - startPosition
      const duration = 1000
      let startTime = null

      const ease = (t, b, c, d) => {
        t /= d / 2
        if (t < 1) return (c / 2) * t * t + b
        t--
        return (-c / 2) * (t * (t - 2) - 1) + b
      }

      const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime
        const timeElapsed = currentTime - startTime
        const run = ease(timeElapsed, startPosition, distance, duration)
        window.scrollTo(0, run)
        if (timeElapsed < duration) requestAnimationFrame(animation)
      }

      requestAnimationFrame(animation)
    }
  }

  function scrollToClassName(classname) {
    const element = document.querySelector(`.${classname}`);
    if (element) {
      const offset = -20;
      const targetPosition = element.getBoundingClientRect().top + window.scrollY + offset;
      const startPosition = window.scrollY;
      const distance = targetPosition - startPosition;
      const duration = 1000;
      let startTime = null;
  
      const ease = (t, b, c, d) => {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      };
  
      const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      };
  
      requestAnimationFrame(animation);
    }
  }

  function truncate(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }
    const truncatedText = text.substring(0, maxLength);
    const lastSpaceIndex = truncatedText.lastIndexOf(' ');
    return lastSpaceIndex > 0 ? truncatedText.substring(0, lastSpaceIndex) + '...' : truncatedText + '...';
  }
  

  return {
    translate,
    registerError,
    scrollToAnchor,
    scrollToClassName,
    truncate
  }
}
